import { Link, useNavigate } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import * as yup from 'yup';
import { userSignUp } from '../api/user.api';
import React, { useState } from 'react';
import { Box, Button, Stack, TextField } from '@mui/material';

const SignupPage = () => {
    const navigate = useNavigate();

    const [isRequest, setIsRequest] = useState(false);

    const form = useFormik({
        initialValues: {
            email: '',
            username: '',
            password: '',
            confirmPassword: '',
        },
        validationSchema: yup.object({
            email: yup.string().email('Invalid email').required('Email is required'),
            username: yup.string().required('Username is required').min(6).max(20),
            password: yup.string().required('Password is requried').min(6),
            confirmPassword: yup
                .string()
                .required('Confirm password is requried')
                .min(6)
                .oneOf([yup.ref('password')], 'Confirm password not match'),
        }),
        onSubmit: (values) => onSignUp(values),
    });

    const onSignUp = async ({ username, password }) => {
        if (isRequest){
            return;
        } 
        setIsRequest(true);

        const res = await userSignUp({ username, password });

        setIsRequest(false);

        if (res.success) {
            toast.success('Signup success');
            navigate('/signin');
        }else{
            toast.error(res.msg);
        }

    };

    return (
        <Box component="form" noValidate onSubmit={form.handleSubmit}>
            <Stack spacing={3}>
                <TextField
                    fullWidth
                    placeholder="Username"
                    name="username"
                    value={form.values.username}
                    onChange={form.handleChange}
                    error={form.touched.username && form.errors.username !== undefined}
                    helperText={form.touched.username && form.errors.username}
                />
                <TextField
                    fullWidth
                    placeholder="Email"
                    name="email"
                    value={form.values.email}
                    onChange={form.handleChange}
                    error={form.touched.email && form.errors.email !== undefined}
                    helperText={form.touched.email && form.errors.email}
                />
                <TextField
                    fullWidth
                    type="password"
                    placeholder="Password"
                    name="password"
                    value={form.values.password}
                    onChange={form.handleChange}
                    error={form.touched.password && form.errors.password !== undefined}
                    helperText={form.touched.password && form.errors.password}
                />
                <TextField
                    fullWidth
                    type="password"
                    placeholder="Confirm Password"
                    name="confirmPassword"
                    value={form.values.confirmPassword}
                    onChange={form.handleChange}
                    error={form.touched.confirmPassword && form.errors.confirmPassword !== undefined}
                    helperText={form.touched.confirmPassword && form.errors.confirmPassword}
                />
                <LoadingButton type="submit" size="large" variant="contained" loading={isRequest} color="success">
                    signup
                </LoadingButton>
                <Button component={Link} to="/signin" size="large">
                    signin
                </Button>
            </Stack>
        </Box>
    );
};

export default SignupPage;
